<template>
  <div id="app" class="app-container" :class="$route.name">
    <div class="app-logo">
      <div class="app-logo__inner">
        <img class="app-logo__image" src="../src/assets/svg/logo.svg" alt="">
      </div>
    </div>

    <div class="modal-controls"></div>
    <div class="modal-container">
      <div class="modal-container__inner">
        <div class="modal-container__wrap"></div>
      </div>
    </div>
    <div class="modal-mask"></div>

    <div class="view-loader">
      <div class="view-loader__panel"></div>
    </div>

    <progress-bar :key="$route.fullPath"></progress-bar>
    <view-container></view-container>
  </div>
</template>

<script>
  import ProgressBar from './components/ProgressBar.vue'
  import ViewContainer from './components/ViewContainer.vue'

  export default {
    name: 'app',
    components: {
      ProgressBar,
      ViewContainer
    }
  }
</script>

<style src="./styles/main.css"></style>



// WEBPACK FOOTER //
// App.vue?54ff0d86